import { ref } from "vue";

export const isRecorder = ref(false);
